import { get } from 'lodash';
import {
  Component,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import {
  ISurveyActivity,
  ISurveyHtml,
} from '../../../models/survey/ISurveyContent';
import { BaseElement } from '../../base-element.abstract';
import { SurveyElementType } from '../../enum/SurveyElementType';

@Component({
  selector: 'surveys-element-html-v2',
  templateUrl: './element-html-v2.component.html',
  styleUrls: ['./element-html-v2.component.scss'],
})
export class ElementHtmlV2Component extends BaseElement implements OnChanges {
  @Input()
  public element: ISurveyActivity;

  public htmlElement: ISurveyHtml;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnChanges() {
    this.updateHtml();
  }

  protected languageChanged() {
    this.updateHtml();
  }

  private updateHtml() {
    const template = get(this.element, 'data.template', {});
    const keys = get(this.element, 'data.keys', [] as string[]);
    const rawData = get(this.element, 'data.replaceData', []);
    const instructionActions = get(this.element, 'data.instructionActions', {});
    const renderMultiple = get(this.element, 'data.renderMultiple', false);

    const instructionConvert = {
      ...Object.fromEntries(
        Object.entries(instructionActions).map(([key, value]) => [
          key,
          JSON.stringify(value),
        ])
      ),
    };

    const normalizedData: Record<string, any[]> = Array.isArray(rawData)
      ? rawData.reduce((acc, item) => {
          const lang = (item.languageCode || '').toLowerCase();
          if (!acc[lang]) {
            acc[lang] = [];
          }
          acc[lang].push(item);
          return acc;
        }, {} as Record<string, any[]>)
      : rawData;

    let data = normalizedData[this.language.toLowerCase()] ?? [];

    if (!renderMultiple) {
        data = data.length > 0 ? [data[0]] : [];
    }

    const templateWithValues: Record<string, string> = {};

    Object.entries(template).forEach(([key, value]: [string, any]) => {
      if (Array.isArray(rawData) && rawData.length === 0) {
        templateWithValues[key] = '';
      } else {
        templateWithValues[key] = this.mappingInstructionToHtml(
          value,
          keys,
          instructionConvert
        );
        templateWithValues[key] = this.mappingValueToHtml(
          templateWithValues[key],
          keys,
          data
        );
      }
    });

    this.htmlElement = {
      id: this.element?.id,
      type: SurveyElementType.HTML,
      data: templateWithValues,
    };
  }

  private mappingValueToHtml(
    html: string,
    keys: string[],
    data: Record<string, any>[]
  ): string {
    return data.length > 0
      ? data
          .map((item) => {
            let replaced = html;
            keys.forEach((key) => {
              const regex = new RegExp(`\\$\\{${key}\\}`, 'g');
              replaced = replaced.replace(regex, item[key] ?? '');
            });
            return replaced;
          })
          .join('\n')
      : html;
  }

  private mappingInstructionToHtml(
    html: string,
    keys: string[],
    data: { [k: string]: string }
  ): string {
    let replaced = html;
    keys.forEach((key) => {
      const regex = new RegExp(`\\$\\{${key}\\}`, 'g');
      if(data[key]) {
          replaced =  replaced.replace(regex, data[key]);
      }
    });
    return replaced;
  }
}
